export function mapLensTech(lensTech) {
  const lensTechMap = {
    iris: '8ko',
  }
  return lensTechMap[lensTech] || lensTech
}
